<div class="admin-login-fullscreen">
  <div class="visual-pane" aria-hidden="true">
    <div class="visual-overlay">
      <img class="tiny-splash" src="https://applisound-images.s3.eu-west-3.amazonaws.com/eclats-bleu-404.png" alt="" />
    </div>
    <div class="lang-on-pane">
      <app-language-selector [showTitle]="false"></app-language-selector>
    </div>
  </div>

  <div class="admin-login-container">
    <div class="admin-login-card">
      <div class="admin-login-header">
        <img src="https://applisound-images.s3.eu-west-3.amazonaws.com/applisound-blanc.png" alt="Applisound logo" />
        <h1>{{ 'ADMIN.TITLE' | translate }}</h1>
        <p>{{ 'ADMIN.SUBTITLE' | translate }}</p>
      </div>

      <form [formGroup]="form" (ngSubmit)="onSubmit()" class="admin-login-form">
        <div class="form-group">
          <label for="email">{{ 'ADMIN.EMAIL' | translate }}</label>
          <input id="email" type="email" formControlName="email" [ngClass]="{ invalid: submitted && f['email'].errors }" />
          @if (submitted && f['email'].errors) {
            <div class="error-message">
              @if (f['email'].errors?.['required']) {
                <span>Email required</span>
              }
              @if (f['email'].errors?.['email']) {
                <span>Invalid email</span>
              }
            </div>
          }
        </div>

        <div class="form-group">
          <label for="password">{{ 'ADMIN.PASSWORD' | translate }}</label>
          <input id="password" [type]="'password'" formControlName="password" [ngClass]="{ invalid: submitted && f['password'].errors }" />
          @if (submitted && f['password'].errors) {
            <div class="error-message">
              <span>Password required</span>
            </div>
          }
        </div>

        <div class="form-group">
          <label for="adminCode">{{ 'ADMIN.ADMIN_CODE' | translate }}</label>
          <input id="adminCode" type="text" formControlName="adminCode" [placeholder]="'ADMIN.ADMIN_CODE' | translate" [ngClass]="{ invalid: submitted && f['adminCode'].errors }" />
          @if (submitted && f['adminCode'].errors) {
            <div class="error-message">
              <span>Format: 5 digits + 1 character</span>
            </div>
          }
        </div>

        <button type="submit" class="btn-admin-submit" [disabled]="loading">
          @if (!loading) {
            <span>{{ 'ADMIN.SIGN_IN' | translate }}</span>
          }
          @if (loading) {
            <span class="spinner"></span>
          }
        </button>

        @if (errorMessage) {
          <div class="alert alert-danger">{{ errorMessage }}</div>
        }
      </form>
    </div>
  </div>
</div>

<div class="lang-mobile light">
  <app-language-selector [showTitle]="false"></app-language-selector>
</div>
